<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 20:00:34
 * @LastEditTime: 2021-07-16 11:49:22
 * @LastEditors: lyy
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\ProjectProgress\ProjectProgressDetailInfo.vue
 * @Description: 项目进度查询和办理 - 详情 - 测绘服务事项详细信息
 */
 -->
<template>
  <div id="project-progress-detail-info" class="project-progress-detail-info">
    <div class="detail-box-tab">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        :class="
          active == index
            ? 'detail-box-tab-name activeTab'
            : 'detail-box-tab-name'
        "
        @click="onTabClick(index)"
      >
        {{ item.label }}
      </div>
    </div>
    <div
      :class="
        active == 2 ? 'detail-box-content isOverflow' : 'detail-box-content'
      "
    >
      <div class="detail-box-content-name">{{ unitName }}</div>
      <div class="detail-info">
        <div v-if="active == 2">
          <no-data v-if="rowsList.length == 0" msg="暂无数据"></no-data>
          <div class="cell-box" v-for="(item, index) in rowsList" :key="index">
            <div v-for="column of columns" :key="column.key">
              <van-cell
                :title="column.label"
                :value="item[column.key]"
                :border="false"
                title-class="cell-box-title"
                value-class="cell-box-value"
                class="cell-box-item"
                v-if="
                  column.key != 'CGZT' &&
                    column.key != 'SHJL' &&
                    column.key != 'CGWJ' &&
                    column.key != 'CHCGSHGZD'
                "
              />
              <van-cell
                v-if="column.key == 'SHJL'"
                :title="column.label"
                :value="item[column.key]"
                :border="false"
                title-class="cell-box-title"
                class="cell-box-item"
                :value-class="{
                  'handle-unhandle':
                    item[column.key] == '未审核' ||
                    item[column.key] == '重新修改',
                  'handle-running': item[column.key] == '审核中',
                  'handle-pass': item[column.key] == '合格',
                  'handle-fail': item[column.key] == '不合格'
                }"
              />
              <div
                v-if="column.key == 'CGWJ' || column.key == 'CHCGSHGZD'"
                class="cell-box-file"
              >
                <div class="cell-box-title">{{ column.label }}</div>
                <div class="cell-box-value cell-file">
                  <div
                    v-for="(itm, idx) in item[column.key]"
                    :key="idx"
                    class="cell-file-name"
                  >
                    {{ itm.NAME }}
                  </div>
                </div>
                <div></div>
              </div>
            </div>
            <div
              :class="{
                'result-confrimed-bg': item['CGZT'] == '2',
                'result-refund-bg': item['CGZT'] == '3'
              }"
            >
              <div
                class="result-confirm-text"
                v-if="item['CGZT'] >= '2'"
                v-text="item['CGZT'] == '2' ? '成果已确认' : '成果已退回'"
              ></div>
            </div>
            <div class="detail-item-btn-box" v-if="item['CGZT'] == '1'">
              <div
                class="result-confirm"
                @click.stop="resultConfirm('confirm', item)"
              >
                成果确认
              </div>
              <div
                class="result-refund"
                @click.stop="resultConfirm('refund', item)"
              >
                成果退回
              </div>
            </div>
          </div>
        </div>
        <!-- <div> -->
        <div
          class="cell-box"
          v-else
          v-for="(item, index) in rowsList"
          :key="index"
        >
          <van-cell
            v-for="column of columns"
            :key="column.key"
            :title="column.label"
            :value="item[column.key]"
            :border="false"
            title-class="cell-box-title"
            value-class="cell-box-value"
            class="cell-box-item"
          />
        </div>
      </div>
    </div>

    <van-popup
      v-model="isShowSMSVerify"
      closeable
      round
      position="bottom"
      class="sms-verify-popup"
    >
      <div class="sms-verify-content">
        <div class="sms-verify-title ">{{ verifyTitle }}</div>
        <div class="sms-verify-box">
          <div class="sms-verify-tips">{{ verifyText }}</div>
          <div class="verify-code-panel">
            <van-field
              class="border-panel"
              v-model="mobileNum"
              clearable
              type="number"
              maxlength="13"
              placeholder="请输入手机号"
              disabled
            >
              <template #left-icon>
                <img
                  src="@/assets/img/projectProgress/mobilephone.png"
                  class="img-sms-icon"
                />
              </template>
            </van-field>
          </div>
          <div class="verify-code-panel">
            <van-field
              class="border-panel verify-code"
              v-model="verifyCode"
              clearable
              left-icon="smsCode"
              placeholder="请输入验证码"
              style="width: 56vw;"
              type="number"
              maxlength="6"
            >
              <template #left-icon>
                <img
                  src="@/assets/img/projectProgress/password.png"
                  class="img-sms-icon"
                />
              </template>
            </van-field>
            <van-button
              class="btn-SMS"
              plain
              type="info"
              color="#1D84FF"
              @click.stop="getSMSCode"
              >{{ timeText }}</van-button
            >
          </div>

          <div class="btn-group">
            <van-button
              class="btn-confirm"
              block
              type="info"
              native-type="submit"
              @click.stop="btnConfirm"
              >确认</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
import listMixins from '@/mixins/comListMixins'
import api from '@/utils/api/projectProgress.api.js'
export default {
  name: 'projectProgressDetailInfo',
  mixins: [listMixins],
  components: {
    NoData
  },
  props: {},
  data() {
    return {
      tabList: [], // 标签栏列表
      active: 0, // 当前选中的标签的索引值
      unitName: '', // 工建项目单位名称
      clsxid: '', // 测量事项ID
      rid: '', // 项目业务rid
      resultInfoObj: {
        projectCode: '03132002134653100',
        projectName: '博罗县棠下村地下停车场',
        submitDate: '2021-06-01 21:05:02',
        status: 0,
        list: '下载指南.pdf',
        file: '房产面积测绘.zip',
        opinion: '审核告知单.pdf',
        beizhu: '首次提交',
        isConfirmed: true
      },
      loading: false, //加载
      finished: false, //是否已加载完成
      refreshing: false, //下拉刷新
      data: [], // 每一标签的项目信息列表
      rowsList: [], // 信息列表
      columns: [], // 列表子项的左侧标题数组
      isShowSMSVerify: false, // 是否进行短信验证码验证
      verifyTitle: '', // 短信验证码类型信息
      verifyText: '', // 提示文本信息
      mobileNum: '', // 手机号
      verifyCode: '', // 验证码
      isClick: true, // 是否已经点击获取验证码按钮
      timeText: '获取验证码',
      resultSubmitItem: {} // 成果提交信息的子项
    }
  },
  watch: {},
  computed: {},
  filters: {
    // getStatus(status) {
    //   let statusText = ''
    //   switch (status) {
    //     // 未审核、审核中、合格、不合格、重新修改
    //     case 0:
    //       statusText = '未审核'
    //       break
    //     case 1:
    //       statusText = '审核中'
    //       break
    //     case 2:
    //       statusText = '合格'
    //       break
    //     case 3:
    //       statusText = '不合格'
    //       break
    //     case 4:
    //       statusText = '重新修改'
    //       break
    //   }
    //   return statusText
    // }
  },
  methods: {
    // 获取项目详细信息
    getProjectInfo() {
      let params = {
        clsxid: this.clsxid,
        rid: this.rid
      }
      return new Promise((resolve, reject) => {
        api.getProjectInfo(params).then(
          res => {
            console.log('项目详细信息::', res)
            this.tabList = res.titleColumns
            this.data = res.data
            let obj = res.data[0][this.tabList[0].key]
            let columns = this.getColumns(obj)
            // console.log('---columns', columns)
            this.columns = columns
            this.rowsList = obj.rowsList
            this.mobileNum = obj.rowsList[0].LXDH ? obj.rowsList[0].LXDH : ''
            resolve(res.data)
          },
          rej => {
            reject(rej)
          }
        )
      })
    },
    // 获取每一项标签的列表子项的左侧标题数组
    getColumns(data) {
      // console.log('getColumns::', data)
      let hideColumns = data.hideColumns.filter(item => item != 'CGQD')
      console.log(hideColumns)
      let arr = data['columns'].filter(item => !hideColumns.includes(item.key))
      console.log('arr::', arr)
      return arr
    },
    // 点击每一项标签触发
    onTabClick(idx) {
      console.log('idx', idx)
      this.active = idx
      let obj = this.data[0][this.tabList[idx].key]
      let columns = this.getColumns(obj)
      // console.log('---columns', columns)
      this.columns = columns
      this.rowsList = obj.rowsList
    },
    // 点击弹出窗 -"确认" 按钮
    btnConfirm() {
      // 提交手机号及短信验证码验证
      if (!this.verifyCode) {
        this.$toast('请输入验证码')
      } else {
        let params = {
          rid: this.resultSubmitItem.RID,
          mobilePhone: this.mobileNum,
          validate: this.verifyCode
        }
        if (this.verifyTitle == '成果确认') {
          api.resultsConfirm(params).then(
            res => {
              console.log('---成果确认---', res)
              this.isShowSMSVerify = false
              this.$toast.success('成果确认成功')
              this.active = 2
              this.getProjectInfo().then(result => {
                console.log('成果确认-提交成功', result)
                this.data = result
                this.active = 2
                let obj = this.data[0][this.tabList[2].key]
                let columns = this.getColumns(obj)
                this.columns = columns
                this.rowsList = obj.rowsList
              })
            },
            rej => {
              console.log('---成果确认--失败-', rej.response.data)
              this.$toast.fail(rej.response.data.msg)
            }
          )
        } else {
          api.resultsReturn(params).then(
            res => {
              console.log('---成果退回---', res)
              this.isShowSMSVerify = false
              this.$toast.success('成果退回成功')
              this.active = 2
              this.getProjectInfo().then(result => {
                console.log('成果退回-提交成功', result)
                this.data = result
                this.active = 2
                let obj = this.data[0][this.tabList[2].key]
                let columns = this.getColumns(obj)
                this.columns = columns
                this.rowsList = obj.rowsList
              })
            },
            rej => {
              console.log('---成果退回--失败-', rej.response.data)
              this.$toast.fail(rej.response.data.msg)
            }
          )
        }
      }
    },
    async getSMSCode() {
      // 获取短信验证码
      if (this.isClick) {
        if (this.mobileNum) {
          this.isClick = false
          let seconds = 60
          this.timeText = seconds + 's'
          let timer = setInterval(() => {
            seconds--
            this.timeText = seconds + 's'
            if (seconds < 0) {
              this.timeText = '重新获取'
              this.isClick = true
              clearInterval(timer)
            }
          }, 1000)
          api.sendVerification({mobileNo: this.mobileNum}).then(res => {
            console.log('--获取验证码--', res)
          })
        } else {
          this.$toast.fail('请输入正确的手机号码')
        }
      }
    },
    //
    loadData(data) {
      console.log('data', data)
      return Promise.resolve(this.rowsList)
      // return this.rowsList
    },
    // 点击"成果确认"/"成果退回"触发
    resultConfirm(type, itm) {
      console.log('点击"成果确认"/"成果退回"-itm', itm)
      this.resultSubmitItem = itm
      if (type == 'confirm') {
        this.verifyTitle = '成果确认'
        this.verifyText = '确认成果前请验证手机号码'
      } else if (type == 'refund') {
        this.verifyTitle = '成果退回'
        this.verifyText = '成果退回前请验证手机号码'
      }
      this.isShowSMSVerify = true
    },
    openFile() {
      this.$toast('请用网页端进行成果文件下载查看')
    }
  },
  created() {
    this.clsxid = this.$route.params.clsxid
    this.rid = this.$route.params.rid
    this.unitName = this.$route.params.unitName
    this.getProjectInfo()
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.project-progress-detail-info {
  background: #ffffff;
  height: 100vh;
  // overflow: auto;
  .sms-verify-popup {
    height: 295px;
    width: 100vw;
    border-radius: 5px 5px 0 0;
    .sms-verify-content {
      margin: 16px 22px;

      .sms-verify-title {
        font-size: 21px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        height: 6vw;
        line-height: 6vw;
      }
      .sms-verify-box {
        margin-top: 26px;
        .sms-verify-tips {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #999999;
          margin-bottom: 8px;
        }
      }

      .btn-group {
        .btn-confirm {
          background-color: #1d84ff;
          box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
          border-radius: 5px;
          :active {
            background: #276ad1;
          }
        }
      }

      .border-panel {
        border: 1px solid #dddddd;
        border-radius: 5px;
        margin: 15px 0px 21px 0px;
        position: relative;
        font-size: 16px;
        ::v-deep .van-field__left-icon {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }
      .verify-code-panel {
        position: relative;
        ::v-deep .van-cell__value {
          margin-left: 3vw;
        }
        .btn-SMS {
          position: absolute;
          top: 0;
          right: 0;
          border: 1px solid #1d84ff;
          border-radius: 5px;
          width: 31vw;
        }
      }

      .verify-code {
        width: 56.8vw;
      }
    }
  }

  .van-cell {
    background-color: transparent;
  }
  .detail-box-tab {
    display: flex;
    width: 100%;
    align-items: center;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
    .detail-box-tab-name {
      display: flex;
      flex: 1;
      // padding: 13px 0px;
      align-items: center;
      justify-content: center;
      border-left: 1px solid #dddddd;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      height: 45px;
      text-align: center;
    }
    .activeTab {
      font-weight: bold;
      color: #1d84ff;
    }
  }
  .detail-box-content {
    height: calc(100% - 47px);
    background-color: #f1f3f6;

    .detail-box-content-name {
      font-size: 17px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #222222;
      padding-top: 23px;
      margin-bottom: 20px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2; // 控制多行的行数
      -webkit-box-orient: vertical;
    }
    .detail-info {
      height: calc(100% - 87px);
      overflow: auto;
    }
    .cell-box {
      background: #ffffff;
      box-shadow: 0px 2px 5px 0px rgb(124 130 140 / 20%);
      border-radius: 5px;
      margin: 0 16px 16px 16px;
      position: relative;
      .result-confrimed-bg {
        background-image: url('~@/assets/img/projectProgress/resultconfirmed.png');
        background-repeat: no-repeat;
        width: 80px;
        height: 25px;
        background-size: 100% auto;
        position: absolute;
        top: 11px;
        right: -1vw;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
      }
      .result-refund-bg {
        background-image: url('~@/assets/img/projectProgress/resultrefund.png');
        background-repeat: no-repeat;
        width: 80px;
        height: 25px;
        background-size: 100% auto;
        position: absolute;
        top: 11px;
        right: -1vw;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
      }

      .detail-item-btn-box {
        border: 1px solid #f1f3f6;
        background: #ffffff;
        display: flex;
        padding: 13px 0px;
        justify-content: flex-end;
        .result-confirm {
          width: 90px;
          height: 28px;
          background-color: #1d84ff;
          box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
          border-radius: 14px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 28px;
          text-align: center;
          margin: 0 10px 0 5px;
        }
        .result-refund {
          width: 90px;
          height: 28px;
          background: #f94347;
          box-shadow: 0px 2px 6px 0px rgba(249, 67, 71, 0.5);
          border-radius: 14px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 28px;
          text-align: center;
          margin: 0 13px 0 5px;
        }
      }
      .cell-box-file {
        display: flex;
        padding: 10px 16px 0px 16px;
      }
      .cell-box-title {
        width: 30%;
        flex: none;
        justify-content: flex-end;
        display: flex;
        white-space: pre-line;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;
      }
      .cell-box-value {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        justify-content: flex-start;
        display: flex;
        width: 75%;
        padding-left: 20px;
        text-align: left;
      }
      .cell-file {
        font-size: 14px;
        font-weight: 500;
        color: #1d84ff;
        // display: flex;
        flex-direction: column;
        .cell-file-name {
          padding-bottom: 5px;
        }
      }
      .handle-status {
        width: 50px;
        height: 21px;
        border-radius: 1px;
        flex: none;
        text-align: center;
        padding: 2px 5px;
        margin-left: 20px;
      }
      .handle-unhandle {
        color: #333333;
        background-color: #dddddd;
        // width: 50px;
        // height: 21px;
        border-radius: 1px;
        flex: none;
        text-align: center;
        padding: 0px 5px;
        margin-left: 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
      }
      .handle-pass {
        color: #34cc8c;
        background-color: #dcf4ea;
        // width: 50px;
        // height: 21px;
        border-radius: 1px;
        flex: none;
        text-align: center;
        padding: 0px 5px;
        margin-left: 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
      }
      .handle-fail {
        color: #fa6366;
        background-color: #ffd5d5;
        width: 50px;
        // height: 21px;
        border-radius: 1px;
        flex: none;
        text-align: center;
        padding: 2px 5px;
        margin-left: 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
      }
      .handle-running {
        color: #1d84ff;
        background-color: #d5e4ff;
        // width: 50px;
        // height: 21px;
        border-radius: 1px;
        flex: none;
        text-align: center;
        padding: 0px 5px;
        margin-left: 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
      }
      .cell-box-item {
        padding: 10px 16px 0px 16px;
      }
      .detail-btn {
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        border-top: 1px solid #f1f3f6;
      }
      .detail-title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
      }
    }
    .info-list {
      background: #f1f3f6;
      height: calc(100% - 110px);
      overflow: auto;
    }
  }
  .isOverflow {
    overflow: auto;
  }

  .img-sms-icon {
    width: 16px;
    height: 16px;
  }
}
</style>
